import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PDF_LINKS } from '../../../../constants/workshop-pdf-link';
@Component({
  selector: 'app-participate',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './participate.component.html',
  styleUrl: './participate.component.scss'
})
export class ParticipateComponent {
  readonly PDF_LINKS = PDF_LINKS;
  participateAssets = {
    proposalIcon: 'images/praposalBlack.svg',
    participateImage: 'images/participate.svg'
  };
  public steps = [
    { title: 'Register University', logo: 'images/registerParticipate.svg' },
    { title: 'On-Campus Workshop', logo: 'images/workshopParticipate.svg' },
    { title: 'Explore AIKosh', logo: 'images/exploreParticipate.svg' },
    { title: 'Build with Datasets & Models', logo: 'images/buildParticipate.svg' },
    { title: 'Engage and Get Rewarded', logo: 'images/hackathonParticipate.svg' },
    //{ title: 'Become AIKosh Ambassador', logo: 'images/ambassadorParticipate.svg' }
  ];

  navigateToPDFLink(): void {
    window.open(this.PDF_LINKS.WORKSHOP, '_blank');
  }
}
